<template>
  <div class="simple-dynamic-form">
    <div class="form-holder">
      <p v-if="subtitle">
        {{ subtitle }}
      </p>
      <div class="component-holder mt-8">
        <slot
          :items="items"
          :errors="errors"
          :form="form"
          :field-component="fieldComponent"
        >
          <component
            :is="fieldComponent(field)"
            v-for="field in items"
            :key="field.key"
            v-model="form[field.key]"
            :error="errors.get(field.key)"
            v-bind="field"
            outlined
            rounded
            @update="updateField(field, $event)"
          />
        </slot>
      </div>
    </div>
    <BaseFormControls
      class="justify-end"
      @next="submit"
    >
      <template #next>
        {{ nextText }}
      </template>
    </BaseFormControls>
  </div>
</template>

<script>
import axios from 'axios';

import FormErrors from '@/utils/FormErrors';

export default {
  name: 'SimpleDynamicForm',
  props: {
    action: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    nextText: {
      type: String,
      default: 'Speichern',
    },
    cols: {
      type: Number,
      default: 2,
    },
    subtitle: {
      type: String,
      default: '',
    },
    reference: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      form: this.items.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {}),
      errors: new FormErrors(),
    };
  },
  methods: {
    fieldComponent(field) {
      return field.component || 'BaseInput';
    },
    updateField(field, value) {
      this.$emit(`update:${field.key}`, { field, value });
    },
    submit() {
      this.errors.clear();
      axios.post(this.action, this.form)
        .then((response) => {
          this.responseHandler(response, true, false);
          this.$emit('close');
          this.reference.success({
            data: response.data,
            items: this.items.map((item) => ({
              ...item,
              value: item.type !== 'password' ? this.form[item.key] : '',
            })),
          });
        })
        .catch(({ response }) => {
          this.responseHandler(response, false, false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.simple-dynamic-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  .form-holder {
    display: flex;
    flex-direction: column;
  }

  .component-holder {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(v-bind(cols), minmax(300px, 1fr));
    align-items: baseline;

    .base-input--hidden {
      display: block;
      visibility: hidden;
    }
  }
}
</style>
